import { Alert } from '@shared/components';

interface Props {
    messages: string[];
}

/** 422 reasons placed at one control. Focusable so a failed submit can move focus here. */
export function InvoiceRejectionList({ messages }: Props) {
    if (messages.length === 0) return null;

    return (
        <div tabIndex={-1} data-rejection-target className="rounded-lg">
            <Alert variant="error">
                <div className="space-y-1">
                    <p className="font-medium">This invoice was not accepted:</p>
                    <ul className="list-inside list-disc space-y-1">
                        {messages.map((message, index) => (
                            <li key={index}>{message}</li>
                        ))}
                    </ul>
                </div>
            </Alert>
        </div>
    );
}
